import { useContext } from 'react';
import { Button, makeStyles } from '@material-ui/core';
import { getDataSpaces } from '../../../../api_helper/api';
import SnackbarAlertContext from '../../../../context/SnackbarAlertContext';
import CreateEditDataSpaceContext from '../../context/CreateEditDataSpaceContext';
import EditDataSpaceFormContext from '../../context/EditDataSpaceFormContext';
import MyDataSpacesViewContext from '../../context/MyDataSpacesViewContext';
import { trackEvent } from '../../../../utils/eventTracking';
import { UserProfileContext } from '../../../../UserProfileContext';

// The NextButton component renders the "Next" button and when clicked, verifies the data entered and sets the view to the next page of the dataspace creation process.
const NextButton = () => {
	const userProfile = useContext(UserProfileContext)[0];
	const snackbarAlertContext = useContext(SnackbarAlertContext);
	const createEditDataSpaceContext = useContext(CreateEditDataSpaceContext);
	const myDataSpacesViewContext = useContext(MyDataSpacesViewContext);
	const editDataSpaceFormContext = useContext(EditDataSpaceFormContext);

	const verifyNewDataSpace = async (newDataSpace) => {
		// Verify the DataSpace has a name.
		if (!editDataSpaceFormContext.dataSpace.name) {
			return {
				isValid: false,
				errorMessage: 'Please enter a name for your DataSpace.',
			};
		}

		// Verify that a fantasy league or sports league has been selected.
		if (!editDataSpaceFormContext.selectedFantasyLeague && editDataSpaceFormContext.selectedSportsLeague) {
			return {
				isValid: false,
				errorMessage: 'Please select a fantasy league or a sports league.',
			};
		}

		return { valid: true };
	};

	const nextButtonClickHandler = async () => {
		const isDataSpaceValid = await verifyNewDataSpace(createEditDataSpaceContext.newDataSpace);

		if (!isDataSpaceValid.valid) {
			snackbarAlertContext.setSnackbarAlert({
				msg: isDataSpaceValid.errorMessage,
				severity: 'error',
				autoHide: 5000,
				isSnackbarOpen: true,
			});

			return;
		}

		myDataSpacesViewContext.changeViewHandler('editDataSpaceFormSelectData');

		trackEvent({
			userDetails: { userId: userProfile._id, email: userProfile.email },
			eventDetails: {
				types: ['KissMetrics', 'Segment', 'Encharge', 'GA4'],
				eventName: 'Advanced to Data Selection Page in Edit Dataspace Form',
			},
		});
	};

	return (
		<Button variant="contained" margin="normal" color="primary" onClick={nextButtonClickHandler}>
			Next
		</Button>
	);
};

export default NextButton;
